import eventinfo   from './forms/eventinfo'
import postevent   from './forms/postevent'
import seasondates from './forms/seasondates'
import seasonoil   from './forms/seasonoil'
import seasonfees from './forms/seasonfees'
import seasondivisions from './forms/seasondivisions'
import seasonsetup   from './forms/seasonsetup'
import seasonsettings     from './forms/seasonsettings'
import seasonparticipants from './forms/seasonparticipants'
import seasontemplate from './forms/seasontemplate'
import orphanedevent from './forms/orphanevent'
import managefunds from './forms/managefunds'

export const formsReducer = {
    eventinfo,
    postevent,
    seasonsettings,
    seasondates,
    seasonoil,
    seasonsetup,
    seasonfees,
    seasondivisions,
    seasonparticipants,
    seasontemplate,
    orphanedevent,
    managefunds
}


// WEBPACK FOOTER //
// ./src/redux/reducers/formsReducer.js